export const API_TYPES = {
  AUTH: "auth",
  CRUDLS: "crudls",
};

export const API_APP_NAMES = {
  CRUDLS: "express_crudls",
};
